{
  "ts": 1749485447,
  "tsCommit": 1749485412,
  "repoName": "WebSignup",
  "branchName": "prod",
  "rev": "5a67630",
  "ver": "20250609_1610_WebSignup_prod_5a67630",
  "env": "production",
  "isBranchDeployment": false
}
